import { graphql } from "@opensea/graphql"

export const FaqModuleFragment = graphql(`
  fragment FaqModule on CollectionFAQModule {
    title
    description
    questions: sections {
      question
      answer
    }
  }
`)
